// import 'react-app-polyfill/ie9'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import React from "react"
import ReactDOM from "react-dom"
import * as Sentry from '@sentry/react' // Sentry for error logging
import App from "./App"
import * as serviceWorker from "./serviceWorker"

// Initiate Sentry
Sentry.init({ dsn: "https://43aa450077fc43ecb416b758dc35d98e@o407764.ingest.sentry.io/5277387" })

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
